import { render } from "./Index.vue?vue&type=template&id=82e4df4a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=82e4df4a&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=82e4df4a&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_kh\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e4df4a"]])

export default __exports__